var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.contratoResponsables},scopedSlots:_vm._u([{key:"item.principal",fn:function(ref){
var item = ref.item;
return [_vm._v("\n      "+_vm._s(item.principal ? 'Si' : 'No')+"\n    ")]}},{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [(_vm.mixValidaScopesActions(3))?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":""},on:{"click":function($event){return _vm.borrarResponsableContrato(item)}}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("mdi-delete")])],1)]}}],null,true)},[_c('span',[_vm._v("Borrar")])]):_vm._e()]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }